// @ts-strict-ignore
import {createContext, useContext} from 'react';

export type RolloutContext = {
  onCreateRuntimeProperty: () => void;
};

export const RolloutContext = createContext<RolloutContext>(null);
export const RolloutContextConsumer = RolloutContext.Consumer;
export const RolloutContextProvider = RolloutContext.Provider;
export const useRolloutContext = () => useContext(RolloutContext);
